import { Box, colors } from '@factorialco/deprecated-design-system'

import { ActivationCenterStatuses } from 'modules/finance/components/FinancialWorkspace/components/ActivationCenter/enums'
import { ActivationCenterPercentage } from 'modules/finance/components/FinancialWorkspace/components/ActivationCenter/statuses'

type CircleType = 'small' | 'regular'

interface ProgressCircleProps {
  type: CircleType
  status: ActivationCenterStatuses
  disabled?: boolean
}

const Types: Record<CircleType, { size: string; coverCircleSize: string }> = {
  small: {
    size: 'var(--spacing-s20)',
    coverCircleSize: 'var(--spacing-s12)',
  },
  regular: {
    size: 'var(--spacing-s32)',
    coverCircleSize: 'var(--spacing-s20)',
  },
}

export const ProgressCircle = ({ type, status, disabled }: ProgressCircleProps) => {
  const { size, coverCircleSize } = Types[type]

  const progress = Number(
    Object.keys(ActivationCenterPercentage).find(
      (key) => ActivationCenterPercentage[Number(key)] === status
    )
  )

  return (
    <Box
      position="relative"
      style={{
        width: size,
        height: size,
      }}
      aria-label={`${progress}%`}
    >
      <Box
        background={disabled ? 'grey200' : 'viridian200'}
        borderRadius={{ all: 'rel500' }}
        alignItems="center"
        justifyContent="center"
        style={{
          transform: `scale(${status})`,
          width: size,
          height: size,
        }}
      >
        <Box
          alignItems="center"
          justifyContent="center"
          style={{
            borderRadius: '50%',
            boxSizing: 'border-box',
            width: `calc(${size} - var(--spacing-s4))`,
            height: `calc(${size} - var(--spacing-s4))`,
            background: `conic-gradient(${
              disabled ? colors.grey200 : colors.viridian1000
            } ${progress}%, transparent ${progress}% 100%)`,
          }}
        >
          <Box
            background={disabled ? 'grey200' : 'viridian200'}
            borderRadius={{ all: 'rel500' }}
            style={{
              width: `calc(${coverCircleSize} - var(--spacing-s2))`,
              height: `calc(${coverCircleSize} - var(--spacing-s2))`,
            }}
          />
        </Box>
      </Box>
    </Box>
  )
}
